<template>
	<div id="app">
		<!-- 3.使用组件 -->
		<roheader :shopcart="shopcart" :shopcart_qty="shopcart_qty" :shopcart_total="shopcart_total"
			@data-updated-shopcart="handleShopcartUpdated"></roheader>
		<!-- <testprops title="hellsksksksksks" color='red'></testprops>
		中间内容哦耶 -->
		<!-- 内容 -->
						<el-dialog :title="notify_title" :visible.sync="notifyDialogVisible" width="60%" top='15%'>
							<div v-html="notify_message"/>							
								<span slot="footer" class="dialog-footer">
									<el-button type="primary" @click="notifyDialogVisible = false">确 定</el-button>
								</span>							  
						</el-dialog>					
					
		<div class="ro-home-content">
			<div class="ro-home-content-box">
				<div style="width:100%;overflow: hidden;">
					<!-- 商品 -->
					<div v-for="(item,index) in product_list"
						style="width: 45%;margin: 2%;float:left;padding:20px;background: white;">
						<img :src="item.image"
							style="width:100%;height:249px;border: 1px solid #333;margin-bottom: 10px;" />
						<div style="height:30px;line-height: 30px;color:black;">{{item.name}}</div>
						<div style="height:30px;line-height: 30px;color:orangered;">{{item.price}}元</div>
						<div>
							<span style="float:left;">
								<el-input-number v-model="item.qty" :min="1" label="描述文字"></el-input-number>
							</span>
							<span style="float:right;">
								<el-button type="warning" style="width: 200px;"
									@click="add_to_shopcart($event,item)">加入购物车</el-button>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>
</template>
<script>
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";

	import testprops from "./components/test_props.vue";
	import {
		fetchPost
	} from "@/utils/request"
	export default {
		name: "App",
		data() {
			return {
				notify_title:'',
				notify_message:'',
				dialogVisible:false,
				notifyDialogVisible:false,
				shop: '商城',
				pages: '首页',
				product_list: [],
				shopcart: [],
				shopcart_qty: 0,
				shopcart_total: 0,



			}
		},
		computed: {

		},
		mounted() {
			this.get_order_list()
			this.get_shopcart()
		},

		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			testprops,
		},
		methods: {
						handleClose() {
							this.dialogVisible = false
							// this.turn_to_order_info()
						},
			get_shopcart() {
				var shopcart = localStorage.getItem('shopcart');
				if (shopcart == '' || shopcart == null) {
					shopcart = [];
				} else {
					shopcart = JSON.parse(shopcart)
				}
				var shopcart_qty = 0
				var shopcart_total = 0
				for (var i = 0; i < shopcart.length; i++) {
					shopcart_qty += shopcart[i].qty
					shopcart_total += parseFloat(shopcart[i].total)
				}

				this.shopcart = shopcart
				this.shopcart_qty = shopcart_qty
				this.shopcart_total = shopcart_total.toFixed(2)
			},

			handleShopcartUpdated(updatedData) {
				this.shopcart = parseFloat(updatedData).toFixed(2);
			},
			handleShopcartQtyUpdated(updatedData) {
				this.shopcart_qty = parseFloat(updatedData).toFixed(2);;
			},
			handleShopcartTotalUpdated(updatedData) {
				this.shopcart_total = parseFloat(updatedData).toFixed(2);;
			},

			get_order_list() {
				var self = this
				fetchPost('/ro/web_eshop/product/list/v1', {}).then(response => {
					if (response.data.result == 'fail') {
						self.$message.error('获取失败')
					} else {
						self.product_list = response.data.list
					}
				})
				var notify_message = localStorage.getItem('eshop_notify_message')
				var notify_title = localStorage.getItem('eshop_notify_title')
				this.notify_message = notify_message
				this.notify_title = notify_title
				// debugger

				if (notify_title != '' && notify_message!=null) {
					this.notifyDialogVisible = true
					localStorage.setItem('eshop_notify_message', '')
					localStorage.setItem('eshop_notify_title', '')
				}

			},
			add_to_shopcart(e, item) {
				if (window.localStorage.getItem('eshop_user_id') == 'false' || window.localStorage.getItem(
					'eshop_user_id') == null) {
					this.$message.error('请先登录')
					this.$router.push("/pages/login")
					return
				}
				var product_data = item
				var shopcart = localStorage.getItem('shopcart');
				if (shopcart == '' || shopcart == null) {
					shopcart = [];
				} else {
					shopcart = JSON.parse(shopcart)
				}
				var qty = product_data.qty
				var same_shop_cart = shopcart.filter((item) => item.id == product_data.id)
				// debugger
				if (same_shop_cart.length >= 1) {
					var index = shopcart.indexOf(same_shop_cart[0]);
					debugger
					shopcart[index].qty = shopcart[index].qty + qty;
					var total = (shopcart[index].qty) * product_data.price
					shopcart[index].total = total
				} else {
					// debugger
					product_data.qty = product_data.qty;

					var total = product_data.qty * product_data.price
					// debugger

					product_data.total = total

					shopcart.push(product_data);
				}
				localStorage.setItem('shopcart', JSON.stringify(shopcart));
				this.shopcart = shopcart;
				var shopcart_qty = 0
				var shopcart_total = 0
				for (var i = 0; i < shopcart.length; i++) {
					shopcart_qty += shopcart[i].qty
					shopcart_total += parseFloat(shopcart[i].total)
				}
				this.shopcart_qty = shopcart_qty
				this.shopcart_total = shopcart_total.toFixed(2)
				this.$message.success('添加成功')
			},
		},
	};
</script>
<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.ro-home-content {
		width: 100%;
		background: #F0F0F0;
		overflow: auto;
		padding: 20px 0;
		background-image: url(../static/picture/bg-index-3.png);
		background-repeat: no-repeat;
		background-position: center center;
		background-size: cover;
	}


	.ro-home-content-box {
		width: 1140px;
		margin: auto;
		padding: 40px 0;
	}

	.ro-text-overflow {
		overflow: hidden;
		text-overflow: ellipsis;
		/* 将对象作为弹性伸缩盒子模型显示 */
		display: -webkit-box;
		/* 限制在一个块元素显示的文本的行数 */
		/* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
		-webkit-line-clamp: 2;
		/* 设置或检索伸缩盒对象的子元素的排列方式 */
		-webkit-box-orient: vertical;
	}



	.ro-progress-bar {
		position: absolute;
		top: 30%;
		left: 20px;
		width: 60px;
		background-color: dodgerblue;
		transition: width 0.3s ease;
		height: 5px;
	}

	.ro-nodes {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 70px;
	}

	.ro-node {
		position: relative;
		width: 20px;
		height: 20px;
		line-height: 30px;
		border-radius: 50%;
		background-color: #fff;
		border: 1px solid #ccc;
		cursor: pointer;
		margin-right: 80px;
		margin-bottom: 10px;
		color: #000000;
	}

	.ro-node.active {
		background-color: dodgerblue;
		color: dodgerblue;
	}

	.ro-node-text {
		line-height: 50px;
		width: 120px;
		text-align: left;
		font-size: 14px;
		position: absolute;
		top: -35px;
	}
</style>